<template>
  <div class="fontting">
    <div class="list" >
      <textarea class="textarea" v-model="content" :placeholder="placeholder"/>
      <van-collapse v-model="activeNames" accordion @change="setactiveNames"  class="font-size">
        <van-collapse-item :title="$t('append_field.fontSize')" name="5">
          <template #icon>
            <img src="/static/images/program/taFontSize.png" style="height: 25px;margin-right: 10px">
          </template>
          <div slot="right-icon"></div>
          <!--  字幕大小 小70 中90 大120        -->

          <div style="width: 100%;height: 100%;display: flex;justify-content: center" slot="value">
            <van-stepper v-model="text.txList[0].taFontSize" min="0" integer max="150"></van-stepper>
          </div>
        </van-collapse-item>


        <van-collapse-item :title="$t('append_field.fontColor')" name="1">
          <template #icon>
            <img src="/static/images/program/fontColor.png" style="height: 25px;margin-right: 10px">
          </template>
          <div slot="value" :style="{
            backgroundColor:taColor,
            height:'100%',
            width:'40px'
          }"></div>
          <div slot="right-icon"></div>
          <pickerColor :isShow="showPickerColor" :bottom="bottomPickerColor" @callback='getPickerColor'
                       :initColor="taColor"></pickerColor>
        </van-collapse-item>
        <van-collapse-item :title="$t('append_field.bgColor')" name="2">
          <template #icon>
            <img src="/static/images/program/bgColor.png" style="height: 25px;margin-right: 10px">
          </template>
          <div slot="value" :style="{
            backgroundColor:taBgColor,
             height:'90%',
            width:'40px',
            border: '1px solid #808080FF',
          }"></div>
          <div slot="right-icon"></div>
          <pickerColor :isShow="showPickerColor" :bottom="bottomPickerColor" @callback='getPickerColor'
                       :initColor="taBgColor"></pickerColor>
        </van-collapse-item>
        <!-- 滚动速度-->
        </van-collapse>
      <van-cell  @click="showScrollSpeedPopup = true">
        <template #title>
          <div class="cell-content">
            <img src="/static/images/program/taMoveSpeed.png" style="height: 25px;margin-right: 10px">
            <span>{{ $t('append_field.scrollSpeed') }}</span>
          </div>
        </template>
        <div class="cell-right">
          {{ getSpeedName(text.txList[0].taMoveSpeed) }}
          <van-icon name="arrow"/>
        </div>
      </van-cell>

      <!-- 滚动方向 -->
      <van-cell v-if="text.txList[0].taMoveSpeed !== '0'" @click="showScrollDirectionPopup = true">
        <template #title>
          <div class="cell-content">
            <img src="/static/images/program/taAlignment.png" style="height: 25px;margin-right: 10px">
            <span>{{ $t('append_field.scrollDirection') }}</span>
          </div>
        </template>
        <div class="cell-right">
          {{ getDirectionName(text.txList[0].taMove) }}
          <van-icon name="arrow"/>
        </div>
      </van-cell>

      <!-- 对齐方式 -->
      <van-cell v-if="text.txList[0].taMoveSpeed === '0'" @click="showAlignmentPopup = true">
        <template #title>
          <div class="cell-content">
            <img src="/static/images/program/taAlignment.png" style="height: 25px;margin-right: 10px">
            <span>{{ $t('append_field.alignment') }}</span>
          </div>
        </template>
        <div class="cell-right">
          {{ getAlignmentName(text.txList[0].taAlignment) }}
          <van-icon name="arrow"/>
        </div>
      </van-cell>
      <div class="btn">
        <van-button type="info" @click="submit" size="small">{{$t('append_field.confirm')}}</van-button>
      </div>
    </div>
    <!-- 滚动速度弹窗 -->
    <van-dialog
        v-model="showScrollSpeedPopup"
        :title="$t('append_field.scrollSpeed')"
        show-cancel-button
        @confirm="onSelectSpeed"
        @cancel="showScrollSpeedPopup = false"
        class="select-groupings"
    >
      <div class="radio-group">
        <van-radio-group v-model="selectedSpeed">
          <van-cell-group>
            <van-cell
                v-for="(speed, index) in speedOptions"
                clickable
                :key="index"
                @click="selectSpeed(speed.value)"
                :title="speed.label"
            >
              <template #right-icon>
                <van-radio :name="speed.value" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-dialog>

    <!-- 滚动方向弹窗 -->
    <van-dialog
        v-model="showScrollDirectionPopup"
        :title="$t('append_field.scrollDirection')"
        show-cancel-button
        @confirm="onSelectDirection"
        @cancel="showScrollDirectionPopup = false"
        class="select-groupings"
    >
      <div class="radio-group">
        <van-radio-group v-model="selectedDirection">
          <van-cell-group>
            <van-cell
                v-for="(direction, index) in directionOptions"
                clickable
                :key="index"
                @click="selectDirection(direction.value)"
                :title="direction.label"
            >
              <template #right-icon>
                <van-radio :name="direction.value" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-dialog>

    <!-- 对齐方式弹窗 -->
    <van-dialog
        v-model="showAlignmentPopup"
        :title="$t('append_field.alignment')"
        show-cancel-button
        @confirm="onSelectAlignment"
        @cancel="showAlignmentPopup = false"
        class="select-groupings"
    >
      <div class="radio-group">
        <van-radio-group v-model="selectedAlignment">
          <van-cell-group>
            <van-cell
                v-for="(alignment, index) in Alignment"
                clickable
                :key="index"
                @click="selectAlignment(alignment.value)"
                :title="alignment.name"
            >
              <template #right-icon>
                <van-radio :name="alignment.value" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-dialog>
  </div>

</template>

<script>
  import {mapState} from 'vuex'
  import pickerColor from "@/components/helang-pickerColor.vue";
  import _ from "lodash";
  import {Toast} from "vant";

  export default {
    components: {pickerColor},
    props: {
      text: {
        type: Object,
      },
    },
    data(){
      return{
        backup: '',
        selectedMove:'',
        content: '',
        type: '',
        activeNames: ['1'],
        moveIndex: 0,
        speedIndex: 0,
        Alignment: [
          {value: '1', 'name': this.$t('append_field.topLeft')},
          {value: '2', 'name': this.$t('append_field.topCenter')},
          {value: '3', 'name': this.$t('append_field.topRight')},
          {value: '4', 'name': this.$t('append_field.leftCenter')},
          {value: '5', 'name': this.$t('append_field.center')},
          {value: '6', 'name': this.$t('append_field.rightCenter')},
          {value: '7', 'name': this.$t('append_field.bottomLeft')},
          {value: '8', 'name': this.$t('append_field.bottomCenter')},
          {value: '9', 'name': this.$t('append_field.bottomRight')}
        ],
        showPickerColor: false,
        bottomPickerColor: 0,
        taBgColor: '#00000000',
        taColor: "000000",
        fontColor: false,
        bjColor: false,
        placeholder: this.$t('append_field.enterContent'),
        showScrollSpeedPopup: false,
        showScrollDirectionPopup: false,
        showAlignmentPopup: false,
        selectedSpeed: '1', // 示例数据
        selectedDirection: '0', // 示例数据
        selectedAlignment: '5', // 示例数据
        speedOptions: [
          { value: '0', label: this.$t('append_field.static') },
          { value: '1', label: this.$t('append_field.slow') },
          { value: '2', label: this.$t('append_field.medium') },
          { value: '3', label: this.$t('append_field.fast') }
        ],
        directionOptions: [
          { value: '0', label: this.$t('append_field.leftToRights') },
          { value: '1', label: this.$t('append_field.rightToLefts') },
          { value: '2', label: this.$t('append_field.bottomToTops') }
        ],
      }
    },
    mounted() {
      if(this.text && this.text.txList && this.text.txList[0]){
        this.content=this.text.txList[0].taContent
        this.type=this.text.coType
      }
      if(this.componentsList[this.controlIndex]&&this.componentsList[this.controlIndex].txList[0]){

        this.taColor = this.componentsList[this.controlIndex].txList[0].taColor
        this.taBgColor = this.componentsList[this.controlIndex].txList[0].taBgColor
        this.backup = _.cloneDeep(this.$store.state.componentsList[this.controlIndex])
        this.selectedSpeed=this.componentsList[this.controlIndex].txList[0].taMoveSpeed
        this.selectedDirection=this.componentsList[this.controlIndex].txList[0].taMove
        this.selectedAlignment=this.componentsList[this.controlIndex].txList[0].taAlignment
      }

    },
    methods: {
      submit() {
        if (this.content === '') {
          Toast(this.$t('append_field.enterText'))
          return
        }else {
          Toast(this.$t('append_field.add_success'))
        }
        this.$emit('setText', this.content)
      },
      close() {
        this.$store.state.componentsList[this.controlIndex].txList = this.backup.txList
        this.$set(this.$store.state.componentsList[this.controlIndex], this.controlIndex, this.backup)
        this.$emit('close')
      },
      getPickerColor(color) {
        /* 隐藏弹窗 */
        this.showPickerColor = false
        this.activeNames = []
        /* 判断颜色值是否有效 */
        if (color) {
          if (this.fontColor) {
            this.taColor = color
            this.$store.state.componentsList[this.controlIndex].txList[0].taColor = color
          } else if (this.bjColor) {
            this.taBgColor = color
            this.$store.state.componentsList[this.controlIndex].txList[0].taBgColor = color
          }
          this.$set(this.componentsList, this.controlIndex, this.componentsList[
              this.controlIndex])
        }
      },
      setactiveNames(id) {
        this.fontColor = false
        this.bjColor = false
        if (id === '1') {
          this.fontColor = true
          this.showPickerColor = true
        } else if (id === '2') {
          this.bjColor = true
          this.showPickerColor = true
        }
      },
      edit() {
        this.$emit('edit')
      },
      fullscreen() {
        this.$emit('fullscreen')
      },
      selectSpeed(speed) {
        this.selectedSpeed = speed;
      },
      selectDirection(direction) {
        this.selectedDirection = direction
      },
      selectAlignment(alignment) {
        this.selectedAlignment = alignment
      },
      onSelectSpeed() {
        this.text.txList[0].taMoveSpeed = this.selectedSpeed
        this.showScrollSpeedPopup = false
      },
      onSelectDirection() {
        this.text.txList[0].taMove = this.selectedDirection
        this.showScrollDirectionPopup = false
      },
      onSelectAlignment() {
        this.text.txList[0].taAlignment = this.selectedAlignment
        this.showAlignmentPopup = false
      },
      getSpeedName(speed) {
        const option = this.speedOptions.find(option => option.value === speed)
        return option ? option.label : ''
      },
      getDirectionName(direction) {
        const option = this.directionOptions.find(option => option.value === direction)
        return option ? option.label : ''
      },
      getAlignmentName(alignment) {
        const item = this.Alignment.find((item) => item.value === alignment)
        return item ? item.name : ''
      }
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .fontting {
    .font-size{
      .van-cell::after{
        border-bottom:1px solid #ebedf0 !important;
      }
     /* .van-radio-group--horizontal{
        display: flex;
        justify-content: space-between;
        margin-right:30px;
      }*/
    }
    .cell-content {
      display: flex;
      align-items: center;
    }

    .cell-icon {
      height: 25px;
      margin-right: 10px;
    }

    .cell-right {
      display: flex;

      align-items: center;
    }
    .van-cell__value {
      flex: none;

    }

    .btn {
      text-align: right;
      margin-top: 30px;
    }

    .van-col {
      text-align: center;
    }
    .van-row{
      padding: 10px 16px;
    }
    .activate {
      background: #006EFF;
      color: #fff;
    }

    .van-collapse-item__content {
      line-height: 40px !important;
      padding: 0;
      overflow: hidden;
    }
    .scrollSpeed{
      float: right !important;
    }
    .textarea {
      border: 1px solid #d8d8db;
      background: $uni-text-color-inverse;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 7px;
      width: 100%;
      height: 100px;
      margin-bottom: 20px;
    }
    .fontting-tab {
      height: 50px;
      position: fixed;
      white-space: nowrap;
      overflow-x: auto;
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 30;
      background: #F8F9FD;

      .control-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 50px;

        .control-item-title {
          font-size:  15px;
        }
      }
    }

  }

</style>
